import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Row,
    RightComponents,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    MultiSelectBox,
} from '../../components/Form';
import {
    TableData,
    TableHeader,
    TableBody,
    TableRow,
    TableColumn,
} from '../../components/Table';
import {
    MobileInfoBox,
    Title,
    TextView,
    PanelBox,
    ButtonLink,
    Modal,
} from '../../components/Display';
import TaroffOrderTemplatesEdit from '../orders-templates/TaroffOrderTemplatesEdit';
import TaroffOrderTemplatesDelete from '../orders-templates/TaroffOrderTemplatesDelete';
import TaroffOrderTemplatesNew from '../orders-templates/TaroffOrderTemplatesNew';
import { postData } from '../../Api';

export default function TaroffOrderTemplates(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const handlecomp1 = () => {
        setModal(
            Modal({
                children: <TaroffOrderTemplatesNew onDismiss={() => setModal(null)} />,
                onDismiss: () => setModal(null),
            })
        );
    };
    const [formQShopIdOptions, setFormQShopIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-order-templates/select-data/q-shop-id').then(
            (response) => {
                setFormQShopIdOptions(response.data);
            }
        );
    }, []);
    const handlecomp2 = () => {
        setModal(
            Modal({
                children: <TaroffOrderTemplatesNew onDismiss={() => setModal(null)} />,
                onDismiss: () => setModal(null),
            })
        );
    };
    const [tableData, setTableData] = useState({});
    const [tableSize, setTableSize] = useState(parseInt(allProps['size']) || 20);
    const [tablePage, setTablePage] = useState(parseInt(allProps['page']) || 1);
    const gotoPage = (page, size = undefined) => {
        setTableData({});
        setTablePage(page);
        size && setTableSize(size);
        setSearchParams({ ...searchParams, page: page, size: size || tableSize });
    };
    const clearFilters = () => {
        setFilterQShopId('');
        setSearchParams({});
    };
    const applyFilters = () => {
        const newSearchParams = {};
        filterQShopId && (newSearchParams['q-shop-id'] = filterQShopId);
        navigate({ search: '?' + new URLSearchParams(newSearchParams).toString() });
    };
    const [filterQShopId, setFilterQShopId] = useState(allProps['q-shop-id'] || '');
    useEffect(() => {
        postData('/api/panel/page/taroff-order-templates/table-data', {
            size: tableSize,
            page: tablePage,
            q_shop_id: filterQShopId,
        }).then((response) => {
            setTableData(response.data);
        });
    }, [searchParams, modal, props]);
    const handlecomp3 = (row) => {
        console.log('site-page-edit');
    };
    const handlecomp4 = (row) => {
        console.log('site-page-edit');
    };
    const handlecomp5 = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrderTemplatesEdit id={row.param_id} onDismiss={() => setModal(null)} />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    const handlecomp6 = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrderTemplatesDelete
                        id={row.param_id_2}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    const handlecomp7 = (row) => {
        console.log('button-link');
    };
    return (
        <PanelBox>
            <Row>
                <RightComponents>
                    <Title>قالب های ثبت سفارش</Title>
                </RightComponents>
                <LeftComponents>
                    <Button onClick={handlecomp1} color={'secondary'}>
                        ایجاد قالب
                    </Button>
                </LeftComponents>
            </Row>
            <RightComponents wrap={true}>
                <MultiSelectBox
                    label={'فروشگاه'}
                    options={formQShopIdOptions}
                    value={filterQShopId}
                    onChange={setFilterQShopId}
                />
                <Button rightIcon={'far fa-search'} onClick={applyFilters}>
                    جستجو
                </Button>
                <Button rightIcon={'far fa-trash'} onClick={clearFilters}>
                    پاک کردن
                </Button>
            </RightComponents>
            <TableData total={tableData.total} size={tableSize} page={tablePage} setPage={gotoPage}>
                <TableHeader>
                    <TableRow>
                        <TableColumn mobile={true}>mobile</TableColumn>
                        <TableColumn mobile={false}>شناسه</TableColumn>
                        <TableColumn mobile={false}>فروشگاه</TableColumn>
                        <TableColumn mobile={false}>عنوان</TableColumn>
                        <TableColumn mobile={false}>وزن</TableColumn>
                        <TableColumn mobile={false}>قیمت</TableColumn>
                        <TableColumn mobile={false}> </TableColumn>
                        <TableColumn mobile={false}></TableColumn>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {tableData.rows?.map((row, index) => (
                        <TableRow key={index}>
                            <TableColumn mobile={true}>
                                <MobileInfoBox />
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_id}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_shop_id_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView bold={true}>{row.text_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView format={'money'}>{row.text_weight}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView format={'money'}>{row.text_price}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <LeftComponents>
                                    <Button
                                        onClick={() => handlecomp3(row)}
                                        rightIcon={'far fa-link'}
                                        tooltip={'ویرایش صفحه صفحه ثبت سفارش'}
                                    ></Button>
                                    <Button
                                        onClick={() => handlecomp4(row)}
                                        rightIcon={'far fa-link'}
                                        tooltip={'ویرایش صفحه صفحه ثبت سفارش'}
                                    ></Button>
                                    <Button
                                        onClick={() => handlecomp5(row)}
                                        rightIcon={'far fa-edit'}
                                        tooltip={'ویرایش قالب'}
                                    ></Button>
                                    <Button
                                        onClick={() => handlecomp6(row)}
                                        color={'warn'}
                                        rightIcon={'far fa-trash'}
                                        tooltip={'حذف قالب'}
                                    ></Button>
                                </LeftComponents>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <ButtonLink
                                    onClick={() => handlecomp7(row)}
                                    rightIcon={'far fa-anchor'}
                                    tooltip={'لینک'}
                                ></ButtonLink>
                            </TableColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </TableData>
            {modal && modal}
        </PanelBox>
    );
}
